import React from 'react';
import { CheckIcon } from '@heroicons/react/24/outline';
import { Logo } from '../Marketing/MarketingNav';

const BANNER = `${process.env.REACT_APP_API_URL || 'https://api.air-brief.com'}/media/banners/banner.jpeg`;

// Shared frame for the signed-out account pages (login, sign-up, forgot/reset password,
// verify email): brand panel on large screens, form on the right; matches the landing page.
const AuthShell = ({ title, subtitle, children }) => (
  <div className="min-h-screen bg-slate-950 text-gray-200 lg:grid lg:grid-cols-2">
    <aside className="relative hidden lg:flex flex-col justify-between overflow-hidden p-12">
      <img src={BANNER} alt="" className="absolute inset-0 h-full w-full object-cover object-[70%_center]" />
      <div className="absolute inset-0 bg-gradient-to-br from-slate-950/95 via-slate-950/85 to-primary-900/70" />
      <div className="relative"><Logo /></div>
      <div className="relative max-w-md">
        <p className="text-4xl font-semibold tracking-tight text-white leading-tight">Pass your exams.<br />Ace the screening.</p>
        <ul className="mt-8 space-y-3 text-gray-300">
          {['Real ATPL and DLR exam questions', 'Timed mock exams with full review', 'All 7 airline screening games'].map((t) => (
            <li key={t} className="flex items-center gap-3"><CheckIcon className="h-5 w-5 text-emerald-400" />{t}</li>
          ))}
        </ul>
      </div>
      <p className="relative text-xs text-gray-500">© {new Date().getFullYear()} AirBrief</p>
    </aside>

    <main className="flex min-h-screen items-center justify-center px-4 py-12 sm:px-8">
      <div className="w-full max-w-md">
        <div className="mb-10 lg:hidden"><Logo /></div>
        <h1 className="text-3xl font-semibold tracking-tight text-white">{title}</h1>
        {subtitle && <div className="mt-2 text-sm text-gray-400">{subtitle}</div>}
        <div className="mt-8">{children}</div>
      </div>
    </main>
  </div>
);

export const labelClass = 'mb-1.5 block text-sm font-medium text-gray-300';

export const inputClass =
  'block w-full rounded-lg border border-white/10 bg-white/5 px-3.5 py-3 text-white placeholder-gray-500 focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/40 sm:text-sm';

export const buttonClass =
  'flex w-full items-center justify-center rounded-lg bg-primary-600 px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/50 disabled:cursor-not-allowed disabled:opacity-50';

export const Notice = ({ tone = 'error', children }) => (
  <div
    role={tone === 'error' ? 'alert' : 'status'}
    className={`rounded-lg border p-4 text-sm ${tone === 'error'
      ? 'border-rose-500/30 bg-rose-500/10 text-rose-200'
      : 'border-emerald-500/30 bg-emerald-500/10 text-emerald-200'}`}
  >
    {children}
  </div>
);

export const Divider = ({ children }) => (
  <div className="relative my-6">
    <div className="absolute inset-0 flex items-center"><div className="w-full border-t border-white/10" /></div>
    <div className="relative flex justify-center"><span className="bg-slate-950 px-3 text-xs uppercase tracking-wider text-gray-500">{children}</span></div>
  </div>
);

export default AuthShell;
